import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';

export class MarcaModeloSearch {
    nmMarca: string;
    nmModelo: string;
    keyword: string;
    limit: number;
    offset: number;

    constructor(data:{nmModelo?:string, nmMarca?:string, keyword?:string, limit?:number, offset?:number}) {
        this.nmMarca = data && data.nmMarca;
        this.nmModelo = data && data.nmModelo;
        this.keyword = data && data.keyword;
        this.limit = 100;
    }

    getFilters():IFilter{
        let filtros:IFilter = new HttpFilter([]);

        if(this.nmMarca){
            filtros.addFilter(new Equal('marca', this.nmMarca));
            this.limit = 300;
        }

        if(this.nmModelo){
            filtros.addFilter(new Equal('modelo', this.nmModelo));
            this.limit = 300;
        }

        if(this.keyword) {
            filtros.addFilter(new Equal('keyword', this.keyword));
        }
        
        if(this.limit)
            filtros.addFilter(new Equal('limit', this.limit));

        return filtros;
    }
}